import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';

import { init, getFases } from './inventarioActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Grid from '../../common/layout/grid';
import Button from '../../common/form/button';

const renderTextarea = field => (
  <Grid cols={field.cols}>
    <div className="form-group form-group-sm">
      <label className="label-gt" htmlFor={field.name}>
        {field.label}
      </label>
      <textarea {...field.input} className="form-control" rows={field.rows || 3} style={{ resize: 'vertical' }} />
    </div>
  </Grid>
);

function withSelectChange(handler) {
  return props => (
    <LabelAndSelectForm
      {...props}
      input={{
        ...props.input,
        onChange: e => {
          props.input.onChange(e);
          handler(e, props);
        },
      }}
    />
  );
}

const selector = formValueSelector('inventarioForm');

const STATUS_OPTS = [
  { value: 'INSTALADO', label: 'Instalado' },
  { value: 'DEFEITO', label: 'Com defeito' },
  { value: 'REMOVIDO', label: 'Removido' },
];

class InventarioForm extends Component {
  constructor(props) {
    super(props);
    this.handleGrupoFiltroChange = this.handleGrupoFiltroChange.bind(this);
    this.GrupoFiltroSelect = withSelectChange(this.handleGrupoFiltroChange);
  }

  handleGrupoFiltroChange() {
    this.props.change('controlador_id', '');
    this.props.change('fase_id', '');
  }

  componentDidUpdate(prevProps) {
    if (this.props.controladorId && this.props.controladorId !== prevProps.controladorId) {
      this.props.getFases(this.props.controladorId);
      this.props.change('fase_id', '');
    }
  }

  renderFaseOptions() {
    const { fases } = this.props;
    if (!fases || fases.length === 0) {
      return <option value="">Sem fases / não aplicável</option>;
    }
    return [
      <option key="0" value="">
        Não específico de fase
      </option>,
      ...fases.map(f => (
        <option key={f.id} value={String(f.id)}>
          Fase {f.id} {f.tipo === 2 ? '(Pedestre)' : '(Veicular)'}
        </option>
      )),
    ];
  }

  render() {
    const { handleSubmit, opcoes, isUpdate } = this.props;
    const tipos = opcoes.tipos || [];
    const grupoFiltro = this.props.grupoFisicoFiltro;

    const controladoresFiltrados = grupoFiltro
      ? (opcoes.controladores || []).filter(c => String(c.grupo_fisico_id) === String(grupoFiltro))
      : opcoes.controladores || [];

    return (
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="simple-cad-form-premium manutencao-cad-premium inventario-cad-premium"
      >
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-toolbox" /> Equipamento instalado
              </h4>
              <p>Patrimônio instalado no cruzamento — diferente do estoque de consumo.</p>
            </div>
            <div className="simple-cad-premium-body">
              <Field name="id" component={LabelAndInput} readOnly label="Código" cols="12 2" placeholder="Automático" />
              <Field name="equipamento_tipo_id" component={LabelAndSelectForm} label="Tipo" cols="12 4">
                <option value="">Selecione...</option>
                {tipos.map(t => (
                  <option key={t.id} value={String(t.id)}>
                    {t.nome} ({t.categoria_nome || t.categoria_codigo || '—'})
                  </option>
                ))}
              </Field>
              <Field name="status" component={LabelAndSelectForm} label="Status" cols="12 3">
                {STATUS_OPTS.map(s => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </Field>
              <Field name="etiqueta" component={LabelAndInput} label="Etiqueta / identificação" cols="12 3" placeholder="Ex.: Detector faixa 1" />

              <Field name="grupo_fisico_filtro" component={this.GrupoFiltroSelect} label="Grupo Físico" cols="12 3">
                <option value="">Todos</option>
                {(opcoes.grupos_fisicos || []).map(g => (
                  <option key={g.id} value={g.id}>
                    {g.descricao}
                  </option>
                ))}
              </Field>
              <Field name="controlador_id" component={LabelAndSelectForm} label="Controlador" cols="12 3">
                <option value="">Selecione...</option>
                {controladoresFiltrados.map(c => (
                  <option key={c.id} value={String(c.id)}>
                    {`Ctrl ${String(c.numero_controlador).padStart(2, '0')}${c.endereco ? ` — ${c.endereco}` : ''}`}
                  </option>
                ))}
              </Field>
              <Field name="fase_id" component={LabelAndSelectForm} label="Fase (opcional)" cols="12 3">
                {this.renderFaseOptions()}
              </Field>
              <Field
                name="ordem_servico_instalacao_id"
                component={LabelAndSelectForm}
                label="OS de instalação (opcional)"
                cols="12 3"
              >
                <option value="">Nenhuma</option>
                {(opcoes.ordens_abertas || []).map(os => (
                  <option key={os.id} value={String(os.id)}>
                    {os.numero}
                  </option>
                ))}
              </Field>

              <Field name="fabricante" component={LabelAndInput} label="Fabricante" cols="12 4" />
              <Field name="modelo" component={LabelAndInput} label="Modelo" cols="12 4" />
              <Field name="numero_serie" component={LabelAndInput} label="Nº de série" cols="12 4" />

              <Field name="data_instalacao" component={LabelAndInput} type="date" label="Data instalação" cols="12 3" />
              <Field name="data_garantia_fim" component={LabelAndInput} type="date" label="Garantia até" cols="12 3" />
              <Field name="estoque_item_id" component={LabelAndSelectForm} label="Material de estoque (opcional)" cols="12 6">
                <option value="">Nenhum vínculo</option>
                {(opcoes.estoque_itens || []).map(item => (
                  <option key={item.id} value={String(item.id)}>
                    {item.codigo ? `${item.codigo} — ` : ''}
                    {item.descricao}
                  </option>
                ))}
              </Field>

              <Field name="observacao" component={renderTextarea} label="Observações" cols="12 12" rows="3" />
            </div>
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
          {isUpdate && (
            <span className="manutencao-cad-hint" style={{ marginLeft: 12 }}>
              Use as abas Histórico ou Trocar para registrar movimentações.
            </span>
          )}
        </div>
      </form>
    );
  }
}

InventarioForm = reduxForm({ form: 'inventarioForm', destroyOnUnmount: false })(InventarioForm);

const mapStateToProps = state => ({
  opcoes: state.manutencaoInventario.opcoes,
  fases: state.manutencaoInventario.fases,
  controladorId: selector(state, 'controlador_id'),
  grupoFisicoFiltro: selector(state, 'grupo_fisico_filtro'),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, getFases, change }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InventarioForm);
